/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface MeanfulQtyLevelsRequest {
  /**
   * Base pair id
   */
  pairId: number;
  /**
   * Tier
   */
  tier: MeanfulQtyLevelsRequest.TierEnum;
  /**
   * Level 1
   */
  lvl1?: number;
  /**
   * Level 2
   */
  lvl2?: number;
  /**
   * Level 3
   */
  lvl3?: number;
  /**
   * Level 4
   */
  lvl4?: number;
  /**
   * Level 5
   */
  lvl5?: number;
  /**
   * Level 6
   */
  lvl6?: number;
  /**
   * Level 7
   */
  lvl7?: number;
  /**
   * Level 8
   */
  lvl8?: number;
  /**
   * Level 9
   */
  lvl9?: number;
}
export namespace MeanfulQtyLevelsRequest {
  export const TierEnum = {
    Small: 'SMALL',
    Regular: 'REGULAR',
    Big: 'BIG',
  } as const;
  export type TierEnum = (typeof TierEnum)[keyof typeof TierEnum];
}
